import { Moment } from "moment";

export class TramStop {
    stopId: number;
    arrivalTime: Date;
    distance: number;
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/tram-stop.ts